import { AutoMap } from "@automapper/classes";

export class PrelevementSurfaceEntity {

    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    LieuPrelevement!: number;
    @AutoMap()
    AutreLieuPrelevement!: string;
    @AutoMap()
    MilieuPrelevement!: number;
    @AutoMap()
    Observations!: string;

    PrelevementId?: number;

}